import { useGetDealRowQuery } from '@/features/deals/dealsApi';
import { getUrlFromPipeline } from '@/utils/constants';
import { Box, Link } from '@mui/material';
import React, { useMemo } from 'react';
import { Link as RouterLink } from 'react-router-dom';

const DealInfo = ({ dealId, ...otherParams }) => {
	const { data: dealData } = useGetDealRowQuery(dealId, { skip: !dealId });

	const { sx, ...props } = otherParams ?? {};

	const dealLink = useMemo(() => {
		const path = getUrlFromPipeline(dealData?.pipeline);
		return `${path}/${dealData?.dealId}`;
	}, [dealData?.pipeline, dealData?.dealId]);

	const dealLabel = dealData?.objectType === 'debtor' ? 'debtor' : 'deal';
	const dealName = dealData?.dealName ?? '';

	return dealId ? (
		<Box
			sx={{ overflow: 'hidden', textOverflow: 'ellipsis', ...(sx ?? {}) }}
			{...(props ?? {})}
		>
			<Link
				to={dealLink}
				component={RouterLink}
				variant='task_body'
				noWrap
				sx={{
					textDecoration: 'none',
				}}
			>
				{`${dealLabel} name: ${dealName.length > 20 ? `${dealName.slice(0, 20)}...` : dealName}`}
			</Link>
		</Box>
	) : (
		<></>
	);
	// )}
};

export default DealInfo;
